var gdprCountries = ["AT", "BE", "BG", "BR", "CY", "CZ", "DE", "DK", "EE", "EL", "ES", "FI", "FR", "GB", "GR", "HR", "HU", "IE", "IT", "LT", "LU", "LV", "MT", "NL", "PL", "PT", "RO", "SE", "SI", "SK", "LI", "NO", "IS", "GP", "GF", "MQ", "YT", "RE", "SX", "MF"];
const cautiousCountries = ["AU", "CA", "US"];

const isGdprCountry = (countryCode) => gdprCountries.includes(countryCode);
const isCautiousCountry = (countryCode) => cautiousCountries.includes(countryCode);

export { isGdprCountry, isCautiousCountry };
